import React, { useEffect } from 'react'
import { DeleteOutlined } from '@ant-design/icons'
import { Button, Modal, message } from 'antd'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import useParams from '../../hook/useParams'
import { WhiteWrapper } from './group.styled'
import MainTable from '../../components/Basic/MainTable'
import PopupConfirm from '../../components/Basic/PopupConfirm'
import dayjs from 'dayjs'
import { deleteBrandUser, editBrandUser, fetchBrandUserList } from '../../apis/brand'
import { useNavigate } from 'react-router-dom'

function BrandManagement (props) {
  const { t: ln_t } = useTranslation()
  const navigate = useNavigate()
  const user = useSelector((state) => state.user)
  const { nowGroup, nowBrand, brands } = user || {}
  const params = useParams({ groupId: nowGroup, brandId: nowBrand, includes: 'user' })
  const { handleFetchParams, fetchParams } = params

  const handleDeleteUserBrand = async record => {
    const { brandId, userId, user } = record || {}

    Modal.confirm({
      title: `${ln_t('user.removeUser')}`,
      content: `${ln_t('user.removeUser')} ${user?.name}?`,
      onOk: async () => {
        const result = await deleteBrandUser(brandId, userId)
        if (result?.status === 204) {
          message.success(ln_t('message.success.remove'))
          handleFetchParams('add', {})
        }
      }
    })
  }

  const handleChangeUserBrand = async (record, updateParams) => {
    const { brandId, userId } = record || {}
    const res = await editBrandUser(brandId, userId, updateParams)
    if (res?.status === 200) {
      message.success(ln_t('message.success.modify'))
      handleFetchParams('add', {})
    }
  }

  const apiFunc = async () => fetchBrandUserList(fetchParams)
  const columns = [
    { title: ln_t('user.name'), dataIndex: 'user', render: e => e.name },
    { title: ln_t('user.email'), dataIndex: 'user', render: e => e.email },
    { title: ln_t('util.createdAt'), dataIndex: 'createdAt', sorter: true, render: (time) => dayjs(time).format('YYYY-MM-DD') },
    { title: ln_t('util.updatedAt'), dataIndex: 'updatedAt', sorter: true, render: (time) => dayjs(time).format('YYYY-MM-DD') },
    {
      title: `${ln_t('user.role')}`,
      dataIndex: 'role',
      render: (e, record) => <PopupConfirm type="role" checked={e === 'admin'} onConfirm={() => handleChangeUserBrand(record, { role: e === 'admin' ? 'member' : 'admin' })} />
    },
    {
      title: `${ln_t('util.status')}`,
      dataIndex: 'status',
      render: (e, record) => <PopupConfirm type="status" checked={e} onConfirm={() => handleChangeUserBrand(record, { status: e ? 0 : 1 })} />
    },
    {
      title: ln_t('util.action'),
      dataIndex: 'id',
      render: (id, record) => <Button size="small" icon={<DeleteOutlined />} onClick={() => handleDeleteUserBrand(record)} />
    }
  ]

  useEffect(() => {
    const havePermission = brands?.find(i => i.id === nowBrand)?.brandUser?.role === 'admin'
    if (!havePermission) navigate('/pageNotFound')
  }, [])

  return (
    <WhiteWrapper>
      <h3 style={{ marginBottom: '24px' }}>{ln_t('group.brandUserList')}</h3>
      <MainTable
        columns={columns}
        rowKey="userId"
        apiFunc={apiFunc}
        params={params}
      />
    </WhiteWrapper>
  )
}

export default BrandManagement
